import { defineStore } from 'pinia'

import type { OrderDetail } from '@/view-models/order'

/**
 * 在funbook 付款連結中，為了讓 order detail 資料能在 payment 獲取，所以使用 pinia store 來儲存
 * 也方便未來遷移 vuex 的 order
 */
export const useOrderPaymentStore = defineStore('order-payment', () => {
  const orderDetail = ref<OrderDetail | null>(null)

  return {
    orderDetail,
  }
})
